/* eslint-disable import/no-duplicates */
/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import ApplicationState from 'store/interfaces';
import { connect } from 'react-redux';
import { retrieveEnvironmentMaintenanceHistoryRequest } from 'modules/maintenance/actions';
import {
  EnvironmentMaintenanceHistoryResponse,
  EnvironmentMaintenanceHistoryRetrieveFields,
} from 'modules/maintenance/interfaces';
import MaintenanceHistory from 'components/MaintenanceHistory';

export interface Props {
  isLoadingEnvironmentHistoryMaintenance: boolean;
  environmentMaintenanceHistory: EnvironmentMaintenanceHistoryResponse;
  currentRequest: string;
  currentRequestDate: string;
  environmentMaintenanceHistoryRetrieve: EnvironmentMaintenanceHistoryRetrieveFields;
  retrieveEnvironmentMaintenanceHistoryRequest: (props) => void;
}

const MaintenanceHistoryEnvironment = ({
  isLoadingEnvironmentHistoryMaintenance,
  environmentMaintenanceHistory,
  environmentMaintenanceHistoryRetrieve,
  currentRequest,
  currentRequestDate,
  retrieveEnvironmentMaintenanceHistoryRequest,
}: Props) => {
  return (
    <MaintenanceHistory
      currentRequest={currentRequest}
      currentRequestDate={currentRequestDate}
      maintenanceHistory={environmentMaintenanceHistory}
      maintenanceHistoryRetrieve={environmentMaintenanceHistoryRetrieve}
      isLoadingMaintenance={isLoadingEnvironmentHistoryMaintenance}
      retriever={retrieveEnvironmentMaintenanceHistoryRequest}
      context={'environment'}
    />
  );
};

const mapStateToProps = ({
  maintenance: {
    isLoadingEnvironmentHistoryMaintenance,
    environmentMaintenance,
    environmentMaintenanceHistory,
    environmentMaintenanceHistoryRetrieve,
  },
}: ApplicationState) => ({
  isLoadingEnvironmentHistoryMaintenance,
  environmentMaintenance,
  environmentMaintenanceHistory,
  environmentMaintenanceHistoryRetrieve,
});

export default connect(mapStateToProps, {
  retrieveEnvironmentMaintenanceHistoryRequest,
})(MaintenanceHistoryEnvironment);
